import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;
  width: 100%;
`;

export const LockableContent = styled.div<{ $locked?: boolean }>`
  transition: opacity 0.2s;
  ${({ $locked }) =>
    $locked &&
    `
      opacity: .4;
      pointer-events: none;
      filter: saturate(.4);
    `}
`;

export const LockTooltip = styled.div<{
  $visible: boolean;
  $top: number;
  $left: number;
}>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  transform: translateY(-50%);
  background: #091413;
  border: 1px solid #25382f;
  border-radius: 8px;
  padding: 7px 11px;
  font-size: 11.5px;
  color: #9fc7a6;
  white-space: nowrap;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 9999;
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
    border: 5px solid transparent;
    border-right-color: #25382f;
  }
`;
